import { Panel } from "primereact/panel";
import CreateGeneralFormEntries from "../components/his/general-form-entries/CreateGeneralFormEntries";
import ViewGeneralFormEntries from "../components/his/general-form-entries/ViewGeneralFormEntries";
import { CalculateAge } from "../utils/CalculateAge";
import { sequenceTableTemplate, statusTemplate } from "../utils/squenceTableNo";
import { InvoiceDateBody } from "./BillingConstants";
import { formatDateTime } from "../utils/FormateDateTime";
import { formatHijri } from "../utils/Hijri";
import CustomTable from "../shared/CustomTable";
import CustomChip from "../shared/CustomChip";

export const beneficiaryTableColumnsData = (t) => [
  // {
  //   body: sequenceTableTemplate,
  //   header: t("No"),
  //   style: { width: "3rem" },
  // },
  {
    field: "full_name",
    header: t("FullName"),
  },
  {
    field: "file_no",
    header: t("MRN"),
  },
  {
    field: "old_file_no",
    header: t("Old MRN"),
  },
  {
    field: "document_type",
    header: t("DocumentType"),
  },
  {
    field: "document_id",
    header: t("DocumentNo"),
  },
  {
    field: "beneficiary_type",
    header: t("BeneficiaryType"),
  },
  {
    field: "subscriber_full_name",
    header: t("Subscriber"),
    body: (rowData) => {
      const subscriberName =
        rowData?.subscriber_full_name || rowData?.subscriber?.full_name || "";
      const subscriberDocumentId =
        rowData?.subscriber_document_id ||
        rowData?.subscriber?.document_id ||
        "";
      const subscriberFileNo =
        rowData?.subscriber_file_no || rowData?.subscriber?.file_no || "";
      const subscriberLabel = [subscriberName]
        .filter(Boolean)
        .join(" --- ");

      return subscriberLabel || "--";
    },
  },
  {
    field: "contact",
    header: t("ContactNo"),
  },
  {
    field: "nationality",
    header: t("nationality"),
  },
  {
    field: "martial_status",
    header: t("MartialStatus"),
  },
  {
    field: "age",
    header: t("Age"),
    body: (rowData) => CalculateAge(rowData?.dob),
  },
  {
    field: "created_at",
    header: t("Created At"),
    body: (rowData) =>
      rowData?.created_at ? formatDateTime(rowData.created_at) : "--",
  },
    {
    field: "created_by",
    header: t("Created By"),
    body: (rowData) => rowData?.created_by_name || rowData?.created_by || "--",
  },
];

export const patientDetailsList = (patientDetails, t) => {
  return [
    {
      label: t("PatientName"),
      text: patientDetails?.full_name || "--",
    },
    {
      label: t("BeneficiaryType"),
      text: patientDetails?.beneficiary_type || "--",
    },
    {
      label: t("Subscriber"),
      text:
        [
          patientDetails?.subscriber_full_name ||
            patientDetails?.subscriber?.full_name,
          patientDetails?.subscriber_document_id ||
            patientDetails?.subscriber?.document_id,
          patientDetails?.subscriber_file_no ||
            patientDetails?.subscriber?.file_no,
        ]
          .filter(Boolean)
          .join(" --- ") || "--",
    },
    // {
    //   label: t("MRN"),
    //   text: patientDetails?.mrn || "--",
    // },
    {
      label: t("DateofBirth"),
      text:
        patientDetails?.date_type == "hijri"
          ? formatHijri(patientDetails?.dob)
          : patientDetails?.dob || "--",
    },
    {
      label: t("Gender"),
      text: patientDetails?.gender || "--",
    },
    {
      label: t("Age"),
      text: CalculateAge(patientDetails?.dob) || "--",
    },
    {
      label: t("Created By"),
      text: patientDetails?.created_by_name || patientDetails?.created_by || "--",
    },
    {
      label: t("Created At"),
      text: patientDetails?.created_at
        ? formatDateTime(patientDetails.created_at)
        : "--",
    },
    {
      label: t("ContactNumber"),
      text: patientDetails?.contact || "--",
    },
    {
      label: t("DocumentType"),
      text: patientDetails?.document_type || "--",
    },
    {
      label: t("DocumentID"),
      text: patientDetails?.document_id || "--",
    },
    {
      label: t("MRN"),
      text: patientDetails?.file_no || "--",
    },
    {
      label: t("Old MRN"),
      text: patientDetails?.old_file_no || "--",
    },
    {
      label: t("nationality"),
      text: patientDetails?.nationality || "--",
    },
    {
      label: t("occupation"),
      text: patientDetails?.occupation || "--",
    },
    {
      label: t("martial_status"),
      text: patientDetails?.martial_status || "--",
    },
    {
      label: t("ResidencyType"),
      text: patientDetails?.residency_type || "--",
    },
    {
      label: t("VisaTitle"),
      text: patientDetails?.visa_title || "--",
    },
    {
      label: t("VisaNumber"),
      text: patientDetails?.visa_no || "--",
    },
    {
      label: t("VisaType"),
      text: visaTypeOptions?.find(
        (item) => item.value == patientDetails?.visa_type
      )?.label || "--",
    },
    {
      label: t("PassportNumber"),
      text: patientDetails?.passport_no || "--",
    },
    {
      label: t("BorderNumber"),
      text: patientDetails?.border_no || "--",
    },
    {
      label: t("InsuranceDuration"),
      text: patientDetails?.insurance_duration || "--",
    },
  ];
};

export const emergencyContactColumns = (t) => [
  { field: "type", header: t("Type"), headerCellClass: "!bg-gray-200" },
  {
    field: "first_name",
    header: t("FirstName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "last_name",
    header: t("LastName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "phone_number",
    header: t("PhoneNumber"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "relationship",
    header: t("Relationship"),
    headerCellClass: "!bg-gray-200",
  },
  { field: "comments", header: t("Comments"), headerCellClass: "!bg-gray-200" },
];

export const guarantorColumnsData = (t) => [
  {
    field: "relation_with_patient",
    header: t("RelationWithPatient"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "name",
    header: t("Name"),
    headerCellClass: "!bg-gray-200",
  },
  { field: "gender", header: t("Gender"), headerCellClass: "!bg-gray-200" },
  {
    field: "phone",
    header: t("PhoneNumber"),
    headerCellClass: "!bg-gray-200",
  },
  { field: "address", header: t("Address"), headerCellClass: "!bg-gray-200" },
  { field: "city", header: t("City"), headerCellClass: "!bg-gray-200" },
  {
    field: "nationality",
    header: t("Nationality"),
    headerCellClass: "!bg-gray-200",
  },
];

export const systemTypes = [
  { value: 1, label: "Nationals And Residents" },
  { value: 2, label: "Visitors" },
  { value: 3, label: "Tourists" },
  { value: 4, label: "Premium Residents" },
  { value: 5, label: "Hajj & Umrah Visitors" },
];

export const genderOptions = [
  { value: "male", label: "Male", valueAr: "ذكر", labelAr: "ذكر" },
  { value: "female", label: "Female", valueAr: "أنثى", labelAr: "أنثى" },
  {
    value: "unknown",
    label: "Unknown",
    valueAr: "غير معروف",
    labelAr: "غير معروف",
  },
];

export const beneficiaryTypeOptions = [
  { label: ("Cash"), value: "cash" },
  { label: ("Insurance"), value: "insurance" },
  { label: ("Corporate"), value: "corporate" },
  { label: ("Government"), value: "government" },

];

export const documentTypeOptions = [
  { value: "VP", label: "VISA" },
  { value: "PPN", label: "Passport" },
  { value: "PRC", label: "Permanent Resident Card Number" },
  { value: "MR", label: "Medical record number" },
  { value: "NI", label: "National Card" },
];

export const maritalStatusOptions = [
  { value: "D", label: "Divorced" },
  { value: "L", label: "Legally Separated" },
  { value: "M", label: "Married" },
  { value: "U", label: "Unmarried" },
  { value: "W", label: "Widowed" },
];

export const occupationOptions = [
  { value: "administration", label: "Administration" },
  { value: "agriculture", label: "Agriculture" },
  { value: "business", label: "Business" },
  { value: "education", label: "Education" },
  { value: "housewife", label: "Housewife" },
  { value: "marine", label: "Marine" },
  { value: "medical field", label: "Medical Field" },
  { value: "military", label: "Military" },
  { value: "skilled worker", label: "Skilled Worker" },
  { value: "student", label: "Student" },
  { value: "oil industries", label: "Oil Industries" },
  { value: "unemployed", label: "Unemployed" },
  { value: "others", label: "Others" },
  { value: "unknown", label: "Unknown" },
];

export const religionOptions = [
  { value: "1", label: "Muslim" },
  { value: "2", label: "Christian" },
  { value: "3", label: "Judaism" },
  { value: "4", label: "Buddhism" },
  { value: "5", label: "Zoroastrian" },
  { value: "7", label: "Hinduism" },
  { value: "8", label: "Sikh" },
  { value: "9", label: "Without" },
  { value: "98", label: "Not available" },
  { value: "99", label: "Not mentioned" },
  { value: "0", label: "Other" },
];

export const residencyTypesOptions = [
  { value: "iqama", label: "Iqama" },
  { value: "visa", label: "Visitor" },
  { value: "nationalId", label: "Citizen or Resident" },
];

export const subscriberRelationOptions = [
  { value: null, label: "Please Select" },
  { value: "child", label: "Child" },
  { value: "parent", label: "Parent" },
  { value: "spouse", label: "Spouse" },
  { value: "common", label: "Common" },
  { value: "other", label: "Other" },
  { value: "self", label: "Self" },
  { value: "injuired", label: "Injuired" },
];

export const citiesOptions = [
  { value: "riyadh", label: "Riyadh" },
  { value: "jeddah", label: "Jeddah" },
  { value: "mecca", label: "Mecca" },
  { value: "medina", label: "Medina" },
  { value: "dhahran", label: "Dhahran" },
  { value: "dammam", label: "Dammam" },
  { value: "khobar", label: "Khobar" },
  { value: "tabuk", label: "Tabuk" },
  { value: "abha", label: "Abha" },
  { value: "khamis_mushait", label: "Khamis Mushait" },
  { value: "najran", label: "Najran" },
  { value: "buraydah", label: "Buraydah" },
  { value: "al_hasa", label: "Al Hasa" },
  { value: "al_mubarak", label: "Al Mubarak" },
  { value: "hafar_al_batin", label: "Hafar Al Batin" },
  { value: "al_jouf", label: "Al Jouf" },
  { value: "yanbu", label: "Yanbu" },
  { value: "al_ula", label: "Al Ula" },
  { value: "al_qatif", label: "Al Qatif" },
  { value: "al_madinah", label: "Al Madinah" },
  { value: "asa", label: "Asa" },
  { value: "taif", label: "Taif" },
];
export const visaTypeOptions = [
  { value: 6, name_ar: "مرور", label: "Transit" },
  {
    value: 10,
    name_ar: "سياحية او سياحية - هيا",
    label: "Tourism or Tourist - Haya",
  },
  { value: 14, name_ar: "توصيل بضائع", label: "Cargo Delivery" },
  { value: 23, name_ar: "زيارة تجارية", label: "Business Visit" },
  { value: 24, name_ar: "زيارة عائلية", label: "Family Visit" },
  { value: 21, name_ar: "رجال اعمال", label: "Businessmen" },
  { value: 22, name_ar: "زيارة عمل", label: "Work Visit" },
  { value: 27, name_ar: "زيارة شخصية", label: "Personal Visit" },
  { value: 40, name_ar: "مرافق", label: "Accompanying" },
  { value: 30, name_ar: "زيارة فعالية", label: "Event Visit" },
];

export const subscriberRelationsOptions = [
  { value: "Child", label: "Child" },
  { value: "Parent", label: "Parent" },
  { value: "Spouse", label: "Spouse" },
  { value: "Common Law Spouse", label: "Common Law Spouse" },
  { value: "Self", label: "Self" },
  { value: "Injured Party", label: "Injured Party" },
];

export const emergencyContactTypes = [
  { value: "KIN", label: "KIN" },
  { value: "Emergency Contact", label: "Emergency Contact" },
  { value: "both", label: "Both" },
];

export const patientOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: `${data?.full_name} --- ${data?.document_id} --- ${data?.file_no}${data?.old_file_no ? ` --- ${data.old_file_no}` : ''}`,
      value: data?.patient_id,
      full_name: data?.full_name || "",
      file_no: data?.file_no || "",
      document_id: data?.document_id || "",
      rcm_ref: data?.rcm_ref || "",
      beneficiary_type: data?.beneficiary_type?.toLowerCase() || "cash",
      insurance_plans: data?.insurance_plans || data?.Plan || [],
      nationality: data?.nationality || "",
      city: data?.city || "",
      address: data?.address || "",
      religion: data?.religion || "",
    };
  });
};

export const patientInsurancePlanOptions = (data = []) => {
  return data?.map((plan) => {
    return {
      label: plan?.payer_name || plan?.policy_holder,
      value: plan?.insurance_plan_id || plan?.id,
    };
  });
};

export const payersOptionsFormat = (data = []) => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const groupsMap = {};

  data?.forEach((payer) => {
    const groupKey = payer?.tpa_name_en?.trim() || 'Non TPA';

    if (!groupsMap[groupKey]) {
      groupsMap[groupKey] = {
        label: groupKey,
        options: [],
      };
    }

    groupsMap[groupKey].options.push({
      label: payer?.name,
      value: payer?.payer_id,
      payer: payer,
    });
  });
  const sortedGroups = Object.values(groupsMap).sort((a, b) => {
    if (a.label === 'Non TPA') return -1;
    if (b.label === 'Non TPA') return 1;
    return a.label.localeCompare(b.label);
  });

  return sortedGroups;
};

// export const nationalitiesOptions = [
//   { value: 'Afghan', label: 'Afghan' },
//   { value: 'Albanian', label: 'Albanian' },
//   { value: 'Algerian', label: 'Algerian' },
//   { value: 'Andorran', label: 'Andorran' },
//   { value: 'Angolan', label: 'Angolan' },
//   { value: 'Antiguan or Barbudan', label: 'Antiguan or Barbudan' },
//   { value: 'Argentine', label: 'Argentine' },
//   { value: 'Armenian', label: 'Armenian' },
//   { value: 'Australian', label: 'Australian' },
//   { value: 'Austrian', label: 'Austrian' },
//   { value: 'Azerbaijani', label: 'Azerbaijani' },
//   { value: 'Bahamian', label: 'Bahamian' },
//   { value: 'Bahraini', label: 'Bahraini' },
//   { value: 'Bangladeshi', label: 'Bangladeshi' },
//   { value: 'Barbadian', label: 'Barbadian' },
//   { value: 'Belarusian', label: 'Belarusian' },
//   { value: 'Belgian', label: 'Belgian' },
//   { value: 'Belizean', label: 'Belizean' },
//   { value: 'Beninese', label: 'Beninese' },
//   { value: 'Bhutanese', label: 'Bhutanese' },
//   { value: 'Bolivian', label: 'Bolivian' },
//   { value: 'Bosnian or Herzegovinian', label: 'Bosnian or Herzegovinian' },
//   { value: 'Botswanan', label: 'Botswanan' },
//   { value: 'Brazilian', label: 'Brazilian' },
//   { value: 'Bruneian', label: 'Bruneian' },
//   { value: 'Bulgarian', label: 'Bulgarian' },
//   { value: 'Burkinabé', label: 'Burkinabé' },
//   { value: 'Burundian', label: 'Burundian' },
//   { value: 'Cabo Verdean', label: 'Cabo Verdean' },
//   { value: 'Cambodian', label: 'Cambodian' },
//   { value: 'Cameroonian', label: 'Cameroonian' },
//   { value: 'Canadian', label: 'Canadian' },
//   { value: 'Central African', label: 'Central African' },
//   { value: 'Chadian', label: 'Chadian' },
//   { value: 'Chilean', label: 'Chilean' },
//   { value: 'Chinese', label: 'Chinese' },
//   { value: 'Colombian', label: 'Colombian' },
//   { value: 'Comorian', label: 'Comorian' },
//   { value: 'Congolese (Congo)', label: 'Congolese (Congo)' },
//   { value: 'Congolese (DRC)', label: 'Congolese (DRC)' },
//   { value: 'Costa Rican', label: 'Costa Rican' },
//   { value: 'Croatian', label: 'Croatian' },
//   { value: 'Cuban', label: 'Cuban' },
//   { value: 'Cypriot', label: 'Cypriot' },
//   { value: 'Czech', label: 'Czech' },
//   { value: 'Danish', label: 'Danish' },
//   { value: 'Djiboutian', label: 'Djiboutian' },
//   { value: 'Dominican', label: 'Dominican' },
//   { value: 'Dominican Republic', label: 'Dominican Republic' },
//   { value: 'Ecuadorian', label: 'Ecuadorian' },
//   { value: 'Egyptian', label: 'Egyptian' },
//   { value: 'Salvadoran', label: 'Salvadoran' },
//   { value: 'Equatorial Guinean', label: 'Equatorial Guinean' },
//   { value: 'Eritrean', label: 'Eritrean' },
//   { value: 'Estonian', label: 'Estonian' },
//   { value: 'Eswatini', label: 'Eswatini' },
//   { value: 'Ethiopian', label: 'Ethiopian' },
//   { value: 'Fijian', label: 'Fijian' },
//   { value: 'Finnish', label: 'Finnish' },
//   { value: 'French', label: 'French' },
//   { value: 'Gabonese', label: 'Gabonese' },
//   { value: 'Gambian', label: 'Gambian' },
//   { value: 'Georgian', label: 'Georgian' },
//   { value: 'German', label: 'German' },
//   { value: 'Ghanaian', label: 'Ghanaian' },
//   { value: 'Greek', label: 'Greek' },
//   { value: 'Grenadian', label: 'Grenadian' },
//   { value: 'Guatemalan', label: 'Guatemalan' },
//   { value: 'Guinean', label: 'Guinean' },
//   { value: 'Bissau-Guinean', label: 'Bissau-Guinean' },
//   { value: 'Guyanese', label: 'Guyanese' },
//   { value: 'Haitian', label: 'Haitian' },
//   { value: 'Honduran', label: 'Honduran' },
//   { value: 'Hungarian', label: 'Hungarian' },
//   { value: 'Icelandic', label: 'Icelandic' },
//   { value: 'Indian', label: 'Indian' },
//   { value: 'Indonesian', label: 'Indonesian' },
//   { value: 'Iranian', label: 'Iranian' },
//   { value: 'Iraqi', label: 'Iraqi' },
//   { value: 'Irish', label: 'Irish' },
//   { value: 'Israeli', label: 'Israeli' },
//   { value: 'Italian', label: 'Italian' },
//   { value: 'Jamaican', label: 'Jamaican' },
//   { value: 'Japanese', label: 'Japanese' },
//   { value: 'Jordanian', label: 'Jordanian' },
//   { value: 'Kazakh', label: 'Kazakh' },
//   { value: 'Kenyan', label: 'Kenyan' },
//   { value: 'Kiribati', label: 'Kiribati' },
//   { value: 'North Korean', label: 'North Korean' },
//   { value: 'South Korean', label: 'South Korean' },
//   { value: 'Kuwaiti', label: 'Kuwaiti' },
//   { value: 'Kyrgyz', label: 'Kyrgyz' },
//   { value: 'Lao', label: 'Lao' },
//   { value: 'Latvian', label: 'Latvian' },
//   { value: 'Lebanese', label: 'Lebanese' },
//   { value: 'Basotho', label: 'Basotho' },
//   { value: 'Liberian', label: 'Liberian' },
//   { value: 'Libyan', label: 'Libyan' },
//   { value: 'Liechtenstein', label: 'Liechtenstein' },
//   { value: 'Lithuanian', label: 'Lithuanian' },
//   { value: 'Luxembourgish', label: 'Luxembourgish' },
//   { value: 'Malagasy', label: 'Malagasy' },
//   { value: 'Malawian', label: 'Malawian' },
//   { value: 'Malaysian', label: 'Malaysian' },
//   { value: 'Maldivian', label: 'Maldivian' },
//   { value: 'Malian', label: 'Malian' },
//   { value: 'Maltese', label: 'Maltese' },
//   { value: 'Marshallese', label: 'Marshallese' },
//   { value: 'Mauritanian', label: 'Mauritanian' },
//   { value: 'Mauritian', label: 'Mauritian' },
//   { value: 'Mexican', label: 'Mexican' },
//   { value: 'Micronesian', label: 'Micronesian' },
//   { value: 'Moldovan', label: 'Moldovan' },
//   { value: 'Monégasque', label: 'Monégasque' },
//   { value: 'Mongolian', label: 'Mongolian' },
//   { value: 'Montenegrin', label: 'Montenegrin' },
//   { value: 'Moroccan', label: 'Moroccan' },
//   { value: 'Mozambican', label: 'Mozambican' },
//   { value: 'Burmese', label: 'Burmese' },
//   { value: 'Namibian', label: 'Namibian' },
//   { value: 'Nauruan', label: 'Nauruan' },
//   { value: 'Nepali', label: 'Nepali' },
//   { value: 'Dutch', label: 'Dutch' },
//   { value: 'New Zealander', label: 'New Zealander' },
//   { value: 'Nicaraguan', label: 'Nicaraguan' },
//   { value: 'Nigerien', label: 'Nigerien' },
//   { value: 'Nigerian', label: 'Nigerian' },
//   { value: 'Macedonian', label: 'Macedonian' },
//   { value: 'Norwegian', label: 'Norwegian' },
//   { value: 'Omani', label: 'Omani' },
//   { value: 'Pakistani', label: 'Pakistani' },
//   { value: 'Palauan', label: 'Palauan' },
//   { value: 'Panamanian', label: 'Panamanian' },
//   { value: 'Papua New Guinean', label: 'Papua New Guinean' },
//   { value: 'Paraguayan', label: 'Paraguayan' },
//   { value: 'Peruvian', label: 'Peruvian' },
//   { value: 'Filipino', label: 'Filipino' },
//   { value: 'Polish', label: 'Polish' },
//   { value: 'Portuguese', label: 'Portuguese' },
//   { value: 'Palestinian', label: 'Palestinian' },
//   { value: 'Qatari', label: 'Qatari' },
//   { value: 'Romanian', label: 'Romanian' },
//   { value: 'Russian', label: 'Russian' },
//   { value: 'Rwandan', label: 'Rwandan' },
//   { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
//   { value: 'Saint Lucian', label: 'Saint Lucian' },
//   { value: 'Saint Vincentian', label: 'Saint Vincentian' },
//   { value: 'Samoan', label: 'Samoan' },
//   { value: 'San Marinese', label: 'San Marinese' },
//   { value: 'São Toméan', label: 'São Toméan' },
//   { value: 'Saudi', label: 'Saudi Arabian' },
//   { value: 'Senegalese', label: 'Senegalese' },
//   { value: 'Serbian', label: 'Serbian' },
//   { value: 'Seychellois', label: 'Seychellois' },
//   { value: 'Sierra Leonean', label: 'Sierra Leonean' },
//   { value: 'Singaporean', label: 'Singaporean' },
//   { value: 'Slovak', label: 'Slovak' },
//   { value: 'Slovene', label: 'Slovene' },
//   { value: 'Solomon Islander', label: 'Solomon Islander' },
//   { value: 'Somali', label: 'Somali' },
//   { value: 'South African', label: 'South African' },
//   { value: 'Spanish', label: 'Spanish' },
//   { value: 'Sri Lankan', label: 'Sri Lankan' },
//   { value: 'Sudanese', label: 'Sudanese' },
//   { value: 'Surinamese', label: 'Surinamese' },
//   { value: 'Swedish', label: 'Swedish' },
//   { value: 'Swiss', label: 'Swiss' },
//   { value: 'Syrian', label: 'Syrian' },
//   { value: 'Taiwanese', label: 'Taiwanese' },
//   { value: 'Tajik', label: 'Tajik' },
//   { value: 'Tanzanian', label: 'Tanzanian' },
//   { value: 'Thai', label: 'Thai' },
//   { value: 'Timorese', label: 'Timorese' },
//   { value: 'Togolese', label: 'Togolese' },
//   { value: 'Tongan', label: 'Tongan' },
//   { value: 'Trinidadian or Tobagonian', label: 'Trinidadian or Tobagonian' },
//   { value: 'Tunisian', label: 'Tunisian' },
//   { value: 'Turkish', label: 'Turkish' },
//   { value: 'Turkmen', label: 'Turkmen' },
//   { value: 'Tuvaluan', label: 'Tuvaluan' },
//   { value: 'Ugandan', label: 'Ugandan' },
//   { value: 'Ukrainian', label: 'Ukrainian' },
//   { value: 'Emirati', label: 'Emirati' },
//   { value: 'British', label: 'British' },
//   { value: 'American', label: 'American' },
//   { value: 'Uruguayan', label: 'Uruguayan' },
//   { value: 'Uzbek', label: 'Uzbek' },
//   { value: 'Vanuatuan', label: 'Vanuatuan' },
//   { value: 'Venezuelan', label: 'Venezuelan' },
//   { value: 'Vietnamese', label: 'Vietnamese' },
//   { value: 'Yemeni', label: 'Yemeni' },
//   { value: 'Zambian', label: 'Zambian' },
//   { value: 'Zimbabwean', label: 'Zimbabwean' }
// ]

export const nationalitiesOptions = [
  {
    value: "Afghan",
    value_ar: "أفغاني",
    label_en: "Afghan",
    label_ar: "أفغاني",
  },
  {
    value: "Albanian",
    value_ar: "ألباني",
    label_en: "Albanian",
    label_ar: "ألباني",
  },
  {
    value: "Algerian",
    value_ar: "جزائري",
    label_en: "Algerian",
    label_ar: "جزائري",
  },
  {
    value: "Andorran",
    value_ar: "أندوري",
    label_en: "Andorran",
    label_ar: "أندوري",
  },
  {
    value: "Angolan",
    value_ar: "أنغولي",
    label_en: "Angolan",
    label_ar: "أنغولي",
  },
  {
    value: "Antiguan or Barbudan",
    value_ar: "أنتيغوا وبربودا",
    label_en: "Antiguan or Barbudan",
    label_ar: "أنتيغوا وبربودا",
  },
  {
    value: "Argentine",
    value_ar: "أرجنتيني",
    label_en: "Argentine",
    label_ar: "أرجنتيني",
  },
  {
    value: "Armenian",
    value_ar: "أرميني",
    label_en: "Armenian",
    label_ar: "أرميني",
  },
  {
    value: "Australian",
    value_ar: "أسترالي",
    label_en: "Australian",
    label_ar: "أسترالي",
  },
  {
    value: "Austrian",
    value_ar: "نمساوي",
    label_en: "Austrian",
    label_ar: "نمساوي",
  },
  {
    value: "Azerbaijani",
    value_ar: "أذربيجاني",
    label_en: "Azerbaijani",
    label_ar: "أذربيجاني",
  },
  {
    value: "Bahamian",
    value_ar: "باهامي",
    label_en: "Bahamian",
    label_ar: "باهامي",
  },
  {
    value: "Bahraini",
    value_ar: "بحريني",
    label_en: "Bahraini",
    label_ar: "بحريني",
  },
  {
    value: "Bangladeshi",
    value_ar: "بنغلاديشي",
    label_en: "Bangladeshi",
    label_ar: "بنغلاديشي",
  },
  {
    value: "Barbadian",
    value_ar: "بربادوسي",
    label_en: "Barbadian",
    label_ar: "بربادوسي",
  },
  {
    value: "Belarusian",
    value_ar: "بيلاروسي",
    label_en: "Belarusian",
    label_ar: "بيلاروسي",
  },
  {
    value: "Belgian",
    value_ar: "بلجيكي",
    label_en: "Belgian",
    label_ar: "بلجيكي",
  },
  {
    value: "Belizean",
    value_ar: "بليزي",
    label_en: "Belizean",
    label_ar: "بليزي",
  },
  {
    value: "Beninese",
    value_ar: "بنيني",
    label_en: "Beninese",
    label_ar: "بنيني",
  },
  {
    value: "Bhutanese",
    value_ar: "بوتاني",
    label_en: "Bhutanese",
    label_ar: "بوتاني",
  },
  {
    value: "Bolivian",
    value_ar: "بوليفي",
    label_en: "Bolivian",
    label_ar: "بوليفي",
  },
  {
    value: "Bosnian or Herzegovinian",
    value_ar: "بوسني أو هيرزيغوفيني",
    label_en: "Bosnian or Herzegovinian",
    label_ar: "بوسني أو هيرزيغوفيني",
  },
  {
    value: "Botswanan",
    value_ar: "بوتسواني",
    label_en: "Botswanan",
    label_ar: "بوتسواني",
  },
  {
    value: "Brazilian",
    value_ar: "برازيلي",
    label_en: "Brazilian",
    label_ar: "برازيلي",
  },
  {
    value: "Bruneian",
    value_ar: "بروناي",
    label_en: "Bruneian",
    label_ar: "بروناي",
  },
  {
    value: "Bulgarian",
    value_ar: "بلغاري",
    label_en: "Bulgarian",
    label_ar: "بلغاري",
  },
  {
    value: "Burkinabé",
    value_ar: "بوركيني",
    label_en: "Burkinabé",
    label_ar: "بوركيني",
  },
  {
    value: "Burundian",
    value_ar: "بوروندي",
    label_en: "Burundian",
    label_ar: "بوروندي",
  },
  {
    value: "Cabo Verdean",
    value_ar: "الرأس الأخضر",
    label_en: "Cabo Verdean",
    label_ar: "الرأس الأخضر",
  },
  {
    value: "Cambodian",
    value_ar: "كمبودي",
    label_en: "Cambodian",
    label_ar: "كمبودي",
  },
  {
    value: "Cameroonian",
    value_ar: "كاميروني",
    label_en: "Cameroonian",
    label_ar: "كاميروني",
  },
  {
    value: "Canadian",
    value_ar: "كندي",
    label_en: "Canadian",
    label_ar: "كندي",
  },
  {
    value: "Central African",
    value_ar: "أفريقي مركزي",
    label_en: "Central African",
    label_ar: "أفريقي مركزي",
  },
  {
    value: "Chadian",
    value_ar: "تشادي",
    label_en: "Chadian",
    label_ar: "تشادي",
  },
  {
    value: "Chilean",
    value_ar: "تشيلي",
    label_en: "Chilean",
    label_ar: "تشيلي",
  },
  { value: "Chinese", value_ar: "صيني", label_en: "Chinese", label_ar: "صيني" },
  {
    value: "Colombian",
    value_ar: "كولومبي",
    label_en: "Colombian",
    label_ar: "كولومبي",
  },
  {
    value: "Comorian",
    value_ar: "قُمري",
    label_en: "Comorian",
    label_ar: "قُمري",
  },
  {
    value: "Congolese (Congo)",
    value_ar: "كونغولي (كونغو)",
    label_en: "Congolese (Congo)",
    label_ar: "كونغولي (كونغو)",
  },
  {
    value: "Congolese (DRC)",
    value_ar: "كونغولي (جمهورية الكونغو الديمقراطية)",
    label_en: "Congolese (DRC)",
    label_ar: "كونغولي (جمهورية الكونغو الديمقراطية)",
  },
  {
    value: "Costa Rican",
    value_ar: "كوستاريكي",
    label_en: "Costa Rican",
    label_ar: "كوستاريكي",
  },
  {
    value: "Croatian",
    value_ar: "كرواتي",
    label_en: "Croatian",
    label_ar: "كرواتي",
  },
  { value: "Cuban", value_ar: "كوبي", label_en: "Cuban", label_ar: "كوبي" },
  {
    value: "Cypriot",
    value_ar: "قبرصي",
    label_en: "Cypriot",
    label_ar: "قبرصي",
  },
  { value: "Czech", value_ar: "تشيكي", label_en: "Czech", label_ar: "تشيكي" },
  {
    value: "Danish",
    value_ar: "دنماركي",
    label_en: "Danish",
    label_ar: "دنماركي",
  },
  {
    value: "Djiboutian",
    value_ar: "جيبوتي",
    label_en: "Djiboutian",
    label_ar: "جيبوتي",
  },
  {
    value: "Dominican",
    value_ar: "دومينيكي",
    label_en: "Dominican",
    label_ar: "دومينيكي",
  },
  {
    value: "Dominican Republic",
    value_ar: "جمهورية الدومينيكان",
    label_en: "Dominican Republic",
    label_ar: "جمهورية الدومينيكان",
  },
  {
    value: "Ecuadorian",
    value_ar: "إكوادوري",
    label_en: "Ecuadorian",
    label_ar: "إكوادوري",
  },
  {
    value: "Egyptian",
    value_ar: "مصري",
    label_en: "Egyptian",
    label_ar: "مصري",
  },
  {
    value: "Salvadoran",
    value_ar: "سلفادوري",
    label_en: "Salvadoran",
    label_ar: "سلفادوري",
  },
  {
    value: "Equatorial Guinean",
    value_ar: "غيني استوائي",
    label_en: "Equatorial Guinean",
    label_ar: "غيني استوائي",
  },
  {
    value: "Eritrean",
    value_ar: "إريتري",
    label_en: "Eritrean",
    label_ar: "إريتري",
  },
  {
    value: "Estonian",
    value_ar: "إستوني",
    label_en: "Estonian",
    label_ar: "إستوني",
  },
  {
    value: "Eswatini",
    value_ar: "إسواتيني",
    label_en: "Eswatini",
    label_ar: "إسواتيني",
  },
  {
    value: "Ethiopian",
    value_ar: "إثيوبي",
    label_en: "Ethiopian",
    label_ar: "إثيوبي",
  },
  { value: "Fijian", value_ar: "فيجي", label_en: "Fijian", label_ar: "فيجي" },
  {
    value: "Finnish",
    value_ar: "فنلندي",
    label_en: "Finnish",
    label_ar: "فنلندي",
  },
  { value: "French", value_ar: "فرنسي", label_en: "French", label_ar: "فرنسي" },
  {
    value: "Gabonese",
    value_ar: "غابوني",
    label_en: "Gabonese",
    label_ar: "غابوني",
  },
  {
    value: "Gambian",
    value_ar: "غامبي",
    label_en: "Gambian",
    label_ar: "غامبي",
  },
  {
    value: "Georgian",
    value_ar: "جورجي",
    label_en: "Georgian",
    label_ar: "جورجي",
  },
  {
    value: "German",
    value_ar: "ألماني",
    label_en: "German",
    label_ar: "ألماني",
  },
  {
    value: "Ghanaian",
    value_ar: "غاني",
    label_en: "Ghanaian",
    label_ar: "غاني",
  },
  { value: "Greek", value_ar: "يوناني", label_en: "Greek", label_ar: "يوناني" },
  {
    value: "Grenadian",
    value_ar: "غرينادي",
    label_en: "Grenadian",
    label_ar: "غرينادي",
  },
  {
    value: "Guatemalan",
    value_ar: "غواتيمالي",
    label_en: "Guatemalan",
    label_ar: "غواتيمالي",
  },
  { value: "Guinean", value_ar: "غيني", label_en: "Guinean", label_ar: "غيني" },
  {
    value: "Bissau-Guinean",
    value_ar: "غيني بيساو",
    label_en: "Bissau-Guinean",
    label_ar: "غيني بيساو",
  },
  {
    value: "Guyanese",
    value_ar: "غيانا",
    label_en: "Guyanese",
    label_ar: "غيانا",
  },
  {
    value: "Haitian",
    value_ar: "هايتي",
    label_en: "Haitian",
    label_ar: "هايتي",
  },
  {
    value: "Honduran",
    value_ar: "هندوراس",
    label_en: "Honduran",
    label_ar: "هندوراس",
  },
  {
    value: "Hungarian",
    value_ar: "مجري",
    label_en: "Hungarian",
    label_ar: "مجري",
  },
  {
    value: "Icelandic",
    value_ar: "آيسلندي",
    label_en: "Icelandic",
    label_ar: "آيسلندي",
  },
  { value: "Indian", value_ar: "هندي", label_en: "Indian", label_ar: "هندي" },
  {
    value: "Indonesian",
    value_ar: "إندونيسي",
    label_en: "Indonesian",
    label_ar: "إندونيسي",
  },
  {
    value: "Iranian",
    value_ar: "إيراني",
    label_en: "Iranian",
    label_ar: "إيراني",
  },
  { value: "Iraqi", value_ar: "عراقي", label_en: "Iraqi", label_ar: "عراقي" },
  {
    value: "Irish",
    value_ar: "أيرلندي",
    label_en: "Irish",
    label_ar: "أيرلندي",
  },
  {
    value: "Israeli",
    value_ar: "إسرائيلي",
    label_en: "Israeli",
    label_ar: "إسرائيلي",
  },
  {
    value: "Italian",
    value_ar: "إيطالي",
    label_en: "Italian",
    label_ar: "إيطالي",
  },
  {
    value: "Jamaican",
    value_ar: "جامايكي",
    label_en: "Jamaican",
    label_ar: "جامايكي",
  },
  {
    value: "Japanese",
    value_ar: "ياباني",
    label_en: "Japanese",
    label_ar: "ياباني",
  },
  {
    value: "Jordanian",
    value_ar: "أردني",
    label_en: "Jordanian",
    label_ar: "أردني",
  },
  {
    value: "Kazakh",
    value_ar: "كازاخستاني",
    label_en: "Kazakh",
    label_ar: "كازاخستاني",
  },
  { value: "Kenyan", value_ar: "كيني", label_en: "Kenyan", label_ar: "كيني" },
  {
    value: "Kiribati",
    value_ar: "كيريباتي",
    label_en: "Kiribati",
    label_ar: "كيريباتي",
  },
  {
    value: "North Korean",
    value_ar: "كوري شمالي",
    label_en: "North Korean",
    label_ar: "كوري شمالي",
  },
  {
    value: "South Korean",
    value_ar: "كوري جنوبي",
    label_en: "South Korean",
    label_ar: "كوري جنوبي",
  },
  {
    value: "Kuwaiti",
    value_ar: "كويتي",
    label_en: "Kuwaiti",
    label_ar: "كويتي",
  },
  {
    value: "Kyrgyz",
    value_ar: "قيرغيزستاني",
    label_en: "Kyrgyz",
    label_ar: "قيرغيزستاني",
  },
  { value: "Lao", value_ar: "لاوسي", label_en: "Lao", label_ar: "لاوسي" },
  {
    value: "Latvian",
    value_ar: "لاتفي",
    label_en: "Latvian",
    label_ar: "لاتفي",
  },
  {
    value: "Lebanese",
    value_ar: "لبناني",
    label_en: "Lebanese",
    label_ar: "لبناني",
  },
  {
    value: "Basotho",
    value_ar: "ليسوتو",
    label_en: "Basotho",
    label_ar: "ليسوتو",
  },
  {
    value: "Liberian",
    value_ar: "ليبيري",
    label_en: "Liberian",
    label_ar: "ليبيري",
  },
  { value: "Libyan", value_ar: "ليبي", label_en: "Libyan", label_ar: "ليبي" },
  {
    value: "Liechtenstein",
    value_ar: "ليختنشتاين",
    label_en: "Liechtenstein",
    label_ar: "ليختنشتاين",
  },
  {
    value: "Lithuanian",
    value_ar: "ليتواني",
    label_en: "Lithuanian",
    label_ar: "ليتواني",
  },
  {
    value: "Luxembourgish",
    value_ar: "لوكسمبورغي",
    label_en: "Luxembourgish",
    label_ar: "لوكسمبورغي",
  },
  {
    value: "Malagasy",
    value_ar: "مدغشقري",
    label_en: "Malagasy",
    label_ar: "مدغشقري",
  },
  {
    value: "Malawian",
    value_ar: "مالاوي",
    label_en: "Malawian",
    label_ar: "مالاوي",
  },
  {
    value: "Malaysian",
    value_ar: "ماليزي",
    label_en: "Malaysian",
    label_ar: "ماليزي",
  },
  {
    value: "Maldivian",
    value_ar: "مالديفي",
    label_en: "Maldivian",
    label_ar: "مالديفي",
  },
  { value: "Malian", value_ar: "مالي", label_en: "Malian", label_ar: "مالي" },
  {
    value: "Maltese",
    value_ar: "مالطي",
    label_en: "Maltese",
    label_ar: "مالطي",
  },
  {
    value: "Marshallese",
    value_ar: "جزر مارشال",
    label_en: "Marshallese",
    label_ar: "جزر مارشال",
  },
  {
    value: "Mauritanian",
    value_ar: "موريتاني",
    label_en: "Mauritanian",
    label_ar: "موريتاني",
  },
  {
    value: "Mauritian",
    value_ar: "موريشيوس",
    label_en: "Mauritian",
    label_ar: "موريشيوس",
  },
  {
    value: "Mexican",
    value_ar: "مكسيكي",
    label_en: "Mexican",
    label_ar: "مكسيكي",
  },
  {
    value: "Micronesian",
    value_ar: "ميكرونيسي",
    label_en: "Micronesian",
    label_ar: "ميكرونيسي",
  },
  {
    value: "Moldovan",
    value_ar: "مولدوفي",
    label_en: "Moldovan",
    label_ar: "مولدوفي",
  },
  {
    value: "Monégasque",
    value_ar: "موناكو",
    label_en: "Monégasque",
    label_ar: "موناكو",
  },
  {
    value: "Mongolian",
    value_ar: "منغولي",
    label_en: "Mongolian",
    label_ar: "منغولي",
  },
  {
    value: "Montenegrin",
    value_ar: "الجبل الأسود",
    label_en: "Montenegrin",
    label_ar: "الجبل الأسود",
  },
  {
    value: "Moroccan",
    value_ar: "مغربي",
    label_en: "Moroccan",
    label_ar: "مغربي",
  },
  {
    value: "Mozambican",
    value_ar: "موزمبيقي",
    label_en: "Mozambican",
    label_ar: "موزمبيقي",
  },
  {
    value: "Burmese",
    value_ar: "ميانماري",
    label_en: "Burmese",
    label_ar: "ميانماري",
  },
  {
    value: "Namibian",
    value_ar: "ناميبي",
    label_en: "Namibian",
    label_ar: "ناميبي",
  },
  {
    value: "Nauruan",
    value_ar: "ناورو",
    label_en: "Nauruan",
    label_ar: "ناورو",
  },
  {
    value: "Nepali",
    value_ar: "نيبالي",
    label_en: "Nepali",
    label_ar: "نيبالي",
  },
  { value: "Dutch", value_ar: "هولندي", label_en: "Dutch", label_ar: "هولندي" },
  {
    value: "New Zealander",
    value_ar: "نيوزيلندي",
    label_en: "New Zealander",
    label_ar: "نيوزيلندي",
  },
  {
    value: "Nicaraguan",
    value_ar: "نيكاراغوا",
    label_en: "Nicaraguan",
    label_ar: "نيكاراغوا",
  },
  {
    value: "Nigerien",
    value_ar: "النيجر",
    label_en: "Nigerien",
    label_ar: "النيجر",
  },
  {
    value: "Nigerian",
    value_ar: "نيجيري",
    label_en: "Nigerian",
    label_ar: "نيجيري",
  },
  {
    value: "Macedonian",
    value_ar: "مقدوني",
    label_en: "Macedonian",
    label_ar: "مقدوني",
  },
  {
    value: "Norwegian",
    value_ar: "نرويجي",
    label_en: "Norwegian",
    label_ar: "نرويجي",
  },
  { value: "Omani", value_ar: "عُماني", label_en: "Omani", label_ar: "عُماني" },
  {
    value: "Pakistani",
    value_ar: "باكستاني",
    label_en: "Pakistani",
    label_ar: "باكستاني",
  },
  {
    value: "Palauan",
    value_ar: "بالاو",
    label_en: "Palauan",
    label_ar: "بالاو",
  },
  {
    value: "Panamanian",
    value_ar: "بنمي",
    label_en: "Panamanian",
    label_ar: "بنمي",
  },
  {
    value: "Papua New Guinean",
    value_ar: "بابوا غينيا الجديدة",
    label_en: "Papua New Guinean",
    label_ar: "بابوا غينيا الجديدة",
  },
  {
    value: "Paraguayan",
    value_ar: "باراغواي",
    label_en: "Paraguayan",
    label_ar: "باراغواي",
  },
  {
    value: "Peruvian",
    value_ar: "بيروفي",
    label_en: "Peruvian",
    label_ar: "بيروفي",
  },
  {
    value: "Filipino",
    value_ar: "فلبيني",
    label_en: "Filipino",
    label_ar: "فلبيني",
  },
  {
    value: "Polish",
    value_ar: "بولندي",
    label_en: "Polish",
    label_ar: "بولندي",
  },
  {
    value: "Portuguese",
    value_ar: "برتغالي",
    label_en: "Portuguese",
    label_ar: "برتغالي",
  },
  {
    value: "Palestinian",
    value_ar: "فلسطيني",
    label_en: "Palestinian",
    label_ar: "فلسطيني",
  },
  { value: "Qatari", value_ar: "قطري", label_en: "Qatari", label_ar: "قطري" },
  {
    value: "Romanian",
    value_ar: "روماني",
    label_en: "Romanian",
    label_ar: "روماني",
  },
  { value: "Russian", value_ar: "روسي", label_en: "Russian", label_ar: "روسي" },
  {
    value: "Rwandan",
    value_ar: "رواندي",
    label_en: "Rwandan",
    label_ar: "رواندي",
  },
  {
    value: "Saint Kitts and Nevis",
    value_ar: "سانت كيتس ونيفيس",
    label_en: "Saint Kitts and Nevis",
    label_ar: "سانت كيتس ونيفيس",
  },
  {
    value: "Saint Lucian",
    value_ar: "سانت لوسيا",
    label_en: "Saint Lucian",
    label_ar: "سانت لوسيا",
  },
  {
    value: "Saint Vincentian",
    value_ar: "سانت فنسنت",
    label_en: "Saint Vincentian",
    label_ar: "سانت فنسنت",
  },
  { value: "Samoan", value_ar: "ساموا", label_en: "Samoan", label_ar: "ساموا" },
  {
    value: "San Marinese",
    value_ar: "سان مارينو",
    label_en: "San Marinese",
    label_ar: "سان مارينو",
  },
  {
    value: "São Toméan",
    value_ar: "ساو تومي وبرينسيبي",
    label_en: "São Toméan",
    label_ar: "ساو تومي وبرينسيبي",
  },
  {
    value: "Saudi",
    value_ar: "سعودي",
    label_en: "Saudi Arabian",
    label_ar: "سعودي",
  },
  {
    value: "Senegalese",
    value_ar: "سنغالي",
    label_en: "Senegalese",
    label_ar: "سنغالي",
  },
  { value: "Serbian", value_ar: "صربي", label_en: "Serbian", label_ar: "صربي" },
  {
    value: "Seychellois",
    value_ar: "سيشلي",
    label_en: "Seychellois",
    label_ar: "سيشلي",
  },
  {
    value: "Sierra Leonean",
    value_ar: "سيراليوني",
    label_en: "Sierra Leonean",
    label_ar: "سيراليوني",
  },
  {
    value: "Singaporean",
    value_ar: "سنغافوري",
    label_en: "Singaporean",
    label_ar: "سنغافوري",
  },
  {
    value: "Slovak",
    value_ar: "سلوفاكي",
    label_en: "Slovak",
    label_ar: "سلوفاكي",
  },
  {
    value: "Slovene",
    value_ar: "سلوفيني",
    label_en: "Slovene",
    label_ar: "سلوفيني",
  },
  {
    value: "Solomon Islander",
    value_ar: "جزر سليمان",
    label_en: "Solomon Islander",
    label_ar: "جزر سليمان",
  },
  {
    value: "Somali",
    value_ar: "صومالي",
    label_en: "Somali",
    label_ar: "صومالي",
  },
  {
    value: "South African",
    value_ar: "جنوب أفريقي",
    label_en: "South African",
    label_ar: "جنوب أفريقي",
  },
  {
    value: "Spanish",
    value_ar: "إسباني",
    label_en: "Spanish",
    label_ar: "إسباني",
  },
  {
    value: "Sri Lankan",
    value_ar: "سريلانكي",
    label_en: "Sri Lankan",
    label_ar: "سريلانكي",
  },
  {
    value: "Sudanese",
    value_ar: "سوداني",
    label_en: "Sudanese",
    label_ar: "سوداني",
  },
  {
    value: "Surinamese",
    value_ar: "سورينامي",
    label_en: "Surinamese",
    label_ar: "سورينامي",
  },
  {
    value: "Swedish",
    value_ar: "سويدي",
    label_en: "Swedish",
    label_ar: "سويدي",
  },
  { value: "Swiss", value_ar: "سويسري", label_en: "Swiss", label_ar: "سويسري" },
  { value: "Syrian", value_ar: "سوري", label_en: "Syrian", label_ar: "سوري" },
  {
    value: "Taiwanese",
    value_ar: "تايواني",
    label_en: "Taiwanese",
    label_ar: "تايواني",
  },
  {
    value: "Tajik",
    value_ar: "طاجيكستاني",
    label_en: "Tajik",
    label_ar: "طاجيكستاني",
  },
  {
    value: "Tanzanian",
    value_ar: "تنزاني",
    label_en: "Tanzanian",
    label_ar: "تنزاني",
  },
  {
    value: "Thai",
    value_ar: "تايلاندي",
    label_en: "Thai",
    label_ar: "تايلاندي",
  },
  {
    value: "Timorese",
    value_ar: "تيمور",
    label_en: "Timorese",
    label_ar: "تيمور",
  },
  {
    value: "Togolese",
    value_ar: "توغولي",
    label_en: "Togolese",
    label_ar: "توغولي",
  },
  { value: "Tongan", value_ar: "تونغا", label_en: "Tongan", label_ar: "تونغا" },
  {
    value: "Trinidadian or Tobagonian",
    value_ar: "ترينيداد وتوباغو",
    label_en: "Trinidadian or Tobagonian",
    label_ar: "ترينيداد وتوباغو",
  },
  {
    value: "Tunisian",
    value_ar: "تونسي",
    label_en: "Tunisian",
    label_ar: "تونسي",
  },
  { value: "Turkish", value_ar: "تركي", label_en: "Turkish", label_ar: "تركي" },
  {
    value: "Turkmen",
    value_ar: "تركمانستاني",
    label_en: "Turkmen",
    label_ar: "تركمانستاني",
  },
  {
    value: "Tuvaluan",
    value_ar: "توفالو",
    label_en: "Tuvaluan",
    label_ar: "توفالو",
  },
  {
    value: "Ugandan",
    value_ar: "أوغندي",
    label_en: "Ugandan",
    label_ar: "أوغندي",
  },
  {
    value: "Ukrainian",
    value_ar: "أوكراني",
    label_en: "Ukrainian",
    label_ar: "أوكراني",
  },
  {
    value: "Emirati",
    value_ar: "إماراتي",
    label_en: "Emirati",
    label_ar: "إماراتي",
  },
  {
    value: "British",
    value_ar: "بريطاني",
    label_en: "British",
    label_ar: "بريطاني",
  },
  {
    value: "American",
    value_ar: "أمريكي",
    label_en: "American",
    label_ar: "أمريكي",
  },
  {
    value: "Uruguayan",
    value_ar: "أوروغواي",
    label_en: "Uruguayan",
    label_ar: "أوروغواي",
  },
  {
    value: "Uzbek",
    value_ar: "أوزبكستاني",
    label_en: "Uzbek",
    label_ar: "أوزبكستاني",
  },
  {
    value: "Vanuatuan",
    value_ar: "فانواتو",
    label_en: "Vanuatuan",
    label_ar: "فانواتو",
  },
  {
    value: "Venezuelan",
    value_ar: "فنزويلي",
    label_en: "Venezuelan",
    label_ar: "فنزويلي",
  },
  {
    value: "Vietnamese",
    value_ar: "فيتنامي",
    label_en: "Vietnamese",
    label_ar: "فيتنامي",
  },
  { value: "Yemeni", value_ar: "يمني", label_en: "Yemeni", label_ar: "يمني" },
  {
    value: "Zambian",
    value_ar: "زامبي",
    label_en: "Zambian",
    label_ar: "زامبي",
  },
  {
    value: "Zimbabwean",
    value_ar: "زيمبابوي",
    label_en: "Zimbabwean",
    label_ar: "زيمبابوي",
  },
  {
    value: "Others",
    value_ar: "أخرى",
    label_en: "Others",
    label_ar: "أخرى",
  },
];

export const classTypeOptions = [
  { value: "group", label: "Group" },
  { value: "subgroup", label: "SubGroup" },
  { value: "plan", label: "Plan" },
  { value: "subplan", label: "SubPlan" },
  { value: "class", label: "Class" },
  { value: "subclass", label: "SubClass" },
  { value: "sequence", label: "Sequence" },
  { value: "rxbin", label: "RX BIN" },
  { value: "rxpcn", label: "RX PCN" },
  { value: "rxid", label: "RX Id" },
  { value: "rxgroup", label: "RX Group" },
];

export const GeneralFormsTabs = (props = {}) => {
  let tabs = {
    tabs: [
      {
        name: "Create New Entry",
        content: (
          <CreateGeneralFormEntries {...(props?.createEntryProps || {})} />
        ),
      },
      {
        name: "View Saved Entries",
        content: (
          <ViewGeneralFormEntries {...(props?.viewEntriesProps || {})} />
        ),
      },
    ],
    className: "custom-class",
  };
  return tabs;
};

export const diagnosisTableColumns = [
  {
    body: sequenceTableTemplate,
    header: "No",
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "type",
    header: "Type",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "codeDescription",
    header: "Description",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "codeDescription",
    header: "Description",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "codeId",
    header: "Code Id",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "on_admission",
    header: "On Addmission",
    headerCellClass: "!bg-gray-200",
  },
];

export const patientDiagnosisData = [
  {
    codeId: "E11",
    codeDescription: "Type 2 diabetes mellitus",
    type: "principal",
    on_admission: "false",
  },
  {
    codeId: "I10",
    codeDescription: "Essential (primary) hypertension",
    type: "secondary",
    on_admission: "true",
  },
  {
    codeId: "J45",
    codeDescription: "Asthma",
    type: "secondary",
    on_admission: "false",
  },
];

export const supportingInfosData = [
  {
    category: "chief-complaint",
    code: "R51",
    value: "Headache",
  },
  {
    category: "mental-health",
    code: "F32",
    value: "Depressive episode",
  },
];

export const supportingInfoTableColumns = [
  {
    body: sequenceTableTemplate,
    header: "No",
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "category",
    header: "Category",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "code",
    header: "Code",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "value",
    header: "Value",
    headerCellClass: "!bg-gray-200",
  },
];

export const vitalSignsData = [
  { category: "Heart Rate", reason: "Routine Checkup", value: 72 },
  {
    category: "Blood Pressure",
    reason: "Hypertension Monitoring",
    value: "120/80 mmHg",
  },
  { category: "Temperature", reason: "Fever Screening", value: "98.6°F" },
];

export const vitalSignsColumns = [
  {
    body: sequenceTableTemplate,
    header: "No",
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "category",
    header: "Category",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "value",
    header: "Value",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "reason",
    header: "Reason",
    headerCellClass: "!bg-gray-200",
  },
];

export const labsData = [
  {
    test: "Complete Blood Count (CBC)",
    reason: "Routine Checkup",
    result: "Normal",
  },
  { test: "Blood Glucose", reason: "Diabetes Screening", result: "95 mg/dL" },
  {
    test: "Cholesterol Panel",
    reason: "Heart Health Check",
    result: "Total: 180 mg/dL",
  },
];

export const labsTableColumns = [
  {
    body: sequenceTableTemplate,
    header: "No",
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "test",
    header: "Test",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "reason",
    header: "Reason",
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "result",
    header: "Result",
    headerCellClass: "!bg-gray-200",
  },
];

export const patientPaidBillsTableColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "date",
    header: t("Date"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "invoice_no",
    header: t("InvoiceNo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "amount",
    header: t("Amount"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "payment_method",
    header: t("PaymentMethod"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "status",
    header: t("Status"),
    headerCellClass: "!bg-gray-200",
  },
];

export const payerShareData = [
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "LAB001",
    item_description: "Random Blood Sugar",
    category: "Laboratory",
    gross: 100,
    discount: 20,
    vat: 0,
    net_payable: 80,
    status: "Paid",
    invoice: "10000010",
    payer: "Bupa Arabia",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "XRAY001",
    item_description: "Chest X-ray",
    category: "X-Ray",
    gross: 150,
    discount: 25,
    vat: 0,
    net_payable: 80,
    status: "Paid",
    invoice: "10000010",
    payer: "Bupa Arabia",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "DN001",
    item_description: "Gum Treatment",
    category: "Oral",
    gross: 100,
    discount: 20,
    vat: 0,
    net_payable: 80,
    status: "Paid",
    invoice: "10000010",
    payer: "Bupa Arabia",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "DN002",
    item_description: "Egg Drug",
    category: "Laboratory",
    gross: 100,
    discount: 20,
    vat: 0,
    net_payable: 80,
    status: "Paid",
    invoice: "10000010",
    payer: "Bupa Arabia",
    physician: "Taysir Maher",
  },
];

export const patientShareData = [
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "LAB001",
    item_description: "Random Blood Sugar",
    category: "Laboratory",
    gross: 20,
    discount: 0,
    vat: 0,
    net_payable: 20,
    status: "Paid",
    invoice: "10000010",
    payer: "Self Paid",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "XRAY001",
    item_description: "Chest X-ray",
    category: "X-Ray",
    gross: 20,
    discount: 0,
    vat: 0,
    net_payable: 20,
    status: "Paid",
    invoice: "10000010",
    payer: "Self Paid",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "DN001",
    item_description: "Gum Treatment",
    category: "Oral",
    gross: 20,
    discount: 0,
    vat: 0,
    net_payable: 20,
    status: "Paid",
    invoice: "10000010",
    payer: "Self Paid",
    physician: "Taysir Maher",
  },
  {
    date: "14-05-2025",
    episode: "OPXXXXXX1",
    item_code: "DN002",
    item_description: "Egg Drug",
    category: "Laboratory",
    gross: 20,
    discount: 0,
    vat: 0,
    net_payable: 20,
    status: "Paid",
    invoice: "10000010",
    payer: "Self Paid",
    physician: "Taysir Maher",
  },
];

export const patientBillingColumns = (t) => [
  {
    field: "date",
    header: t("Date"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "episode",
    header: t("Episode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "item_code",
    header: t("Item Code"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "item_description",
    header: t("Item Description"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "category",
    header: t("Category"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "gross",
    header: t("Gross"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "discount",
    header: t("Discount"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vat",
    header: t("VAT"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "net_payable",
    header: t("Net Payable"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "status",
    header: t("Status"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "invoice",
    header: t("Invoice"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "payer",
    header: t("Payer"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "physician",
    header: t("Physician"),
    headerCellClass: "!bg-gray-200",
  },
];
export const companyAmountBody = (el) => {
  return el?.company_share % 1 !== 0
    ? el?.company_share?.toFixed(2)
    : el?.company_share;
};

export const companyVatBody = (el) => {
  return el?.company_vat % 1 !== 0
    ? el?.company_vat?.toFixed(2)
    : el?.company_vat;
};
export const patientVatBody = (el) => {
  return el?.patient_vat % 1 !== 0
    ? el?.patient_vat?.toFixed(2)
    : el?.patient_vat;
};

export const companyPaidAmountBody = (el) => {
  return el?.total_amount % 1 !== 0
    ? el?.total_amount?.toFixed(2)
    : el?.total_amount;
};

export const companyStatusBody = (el) => {
  let rowData = { status: el?.company_status };
  return statusTemplate(rowData);
};

export const patientCashColumns = (t) => [
  { header: t("InvoiceNumber"), field: "invoice_number" },
  { header: t("Date"), body: InvoiceDateBody },
  {
    header: t("PatientName"),
    body: (row) => {
      return row?.patient?.full_name;
    },
  },
  { header: t("MRN"), field: "file_number" },
  {
    header: t("Payer"),
    body: (row) => {
      return row?.payer?.name;
    },
  },
  { header: t("CompanyAmount"), body: companyAmountBody },
  { header: t("CompanyVat"), body: companyVatBody },
  { header: t("CompanyPaidAmount"), body: companyPaidAmountBody },
  { header: t("Status"), body: companyStatusBody },
];

export const patientCompanyColumns = (t) => [
  { header: t("Date"), body: InvoiceDateBody, headerCellClass: "!bg-gray-200" },
  {
    header: t("InvoiceNumber"),
    body: (row) => {
      return row?.insurance_invoice_number || row?.cash_invoice_number;
    },
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("invoice_type"),
    field: "invoice_type",
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("Episode"),
    body: (row) => {
      return row?.visit?.episode_id;
    },
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("Practitioner"),
    body: (row) => {
      return row?.visit?.practitioner?.name;
    },
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("Payer"),
    body: (row) => {
      return row?.payer?.name;
    },
    colSpan: 6,
    headerCellClass: "!bg-gray-200",
  },
  // {
  //   header: t("GrossAmount"),
  //   body: (row) => {
  //     return row?.total_gross_amount;
  //   },
  //   headerCellClass: "!bg-gray-200",
  // },
  {
    header: t("Discount"),
    body: (row) => {
      return row?.total_discount;
    },
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("PatientShare"),
    body: (row) => {
      return row?.patient_share;
    },
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("CompanyShare"),
    body: (row) => {
      return row?.company_share;
    },
    headerCellClass: "!bg-gray-200",
  },

  {
    header: t("PatientVat"),
    body: patientVatBody,
    headerCellClass: "!bg-gray-200",
  },
  {
    header: t("CompanyVat"),
    body: companyVatBody,
    headerCellClass: "!bg-gray-200",
  },

  {
    header: t("Visit Type"),
    field: "visit.episode_type",
    headerCellClass: "!bg-gray-200",
  },
  // {
  //   header: t("Priority"),
  //   body: (row) => (
  //     <CustomChip
  //       label={row?.visit?.priority?.coding?.[0]?.display}
  //       chipType={
  //         row?.visit?.priority?.coding?.[0]?.code == "s" ||
  //           row?.visit?.priority?.coding?.[0]?.code == "em"
  //           ? "danger"
  //           : "default"
  //       }
  //       size="small"
  //       className="h-[25px] cursor-pointer rounded-md"
  //     />
  //   ),
  //   headerCellClass: "!bg-gray-200",
  // },
];

export const rowExpansionPatientBillingTemplate = (data, t) => {
  const items = data?.items || data?.invoice_details || [];
  const rowData = [
    {
      field: "item_code",
      header: t("Item Code"),
    },
    {
      header: t("ItemName"),
      body: row => row?.item_name || row?.item_name_en || row?.standard_desc || row?.agreed_desc || "-",
      bodyCellClass: "!whitespace-pre-wrap",
    },
    {
      field: "item_type",
      header: t("Type"),
    },
    {
      field: "status",
      header: t("Status"),
    },
    {
      field: "quantity",
      header: t("TotalQuantity"),
    },
    {
      field: "unit_price",
      header: t("Unit Price"),
    },
    {
      field: "gross_amount",
      header: t("Gross"),
    },
    {
      field: "discount_amount",
      header: t("Discount"),
    },
    {
      field: "patient_share",
      header: t("PatientShare"),
    },
    {
      field: "company_share",
      header: t("CompanyShare"),
    },
    {
      header: t("PatientVat"),
      body: row => row?.patient_vat ?? row?.patient_tax_amount ?? 0,
    },
    {
      header: t("CompanyVat"),
      body: row => row?.company_vat ?? row?.company_tax_amount ?? 0,
    },
    {
      field: "total_amount",
      header: t("Total"),
    },
  ];
  return (
    <div className="bg-gray-50 px-3 pb-3">
      <div className="overflow-hidden rounded-md border border-blue-200 bg-white shadow-sm">
        <div className="flex items-center justify-between border-b border-blue-100 bg-blue-50 px-3 py-1.5">
          <span className="text-[12px] font-semibold text-primary">
            {t("Invoice Items")}
          </span>
          <span className="rounded-full bg-white px-2 py-0.5 text-[10px] font-semibold text-gray-500">
            {items.length} {items.length === 1 ? t("item") : t("items")}
          </span>
        </div>
        <CustomTable
          data={items}
          columns={rowData.map(col => ({
            ...col,
            headerCellClass: `!bg-white !py-2 ${col.headerCellClass || ""}`,
            bodyCellClass: `!py-2 !text-[11px] ${col.bodyCellClass || ""}`,
            headerTitleClass: "!text-[11px]",
          }))}
          emptyMessage="No items found"
          rootyStyles="overflow-auto border-0 custom-table"
        />
      </div>
    </div>
  );
};
